import { ActionType, createAction, createAsyncAction } from 'typesafe-actions'

import { Analysis, IdIndexedAnalyses } from './analyses.types'

export const setAnalyses = createAction(
  '/scenes/Dashboard/data/analyses/SET_ANALYSES',
  (resolve) => (analyses: IdIndexedAnalyses) => resolve(analyses)
)

export const fetchOneAnalysis = createAsyncAction(
  '/scenes/Dashboard/data/analyses/ONE_ANALYSIS_FETCH_BEGIN',
  '/scenes/Dashboard/data/analyses/ONE_ANALYSIS_FETCH_SUCCESS',
  '/scenes/Dashboard/data/analyses/ONE_ANALYSIS_FETCH_FAILURE'
)<Analysis['id'], Analysis, Error>()

export const setOneAnalysis = createAction(
  '/scenes/Dashboard/data/analyses/SET_ONE_ANALYSIS',
  (resolve) => (analysis: Analysis) => resolve(analysis)
)

export type AnalysisAction = ActionType<typeof setAnalyses | typeof fetchOneAnalysis | typeof setOneAnalysis>
